export const VpnTypeStringMap = new Map<string, string>([
  ['IN_PROGRESS', 'In Progress'],
  ['SUBMITTED', 'Submitted'],
  ['UNDER_CONFIG', 'Under Configuration'],
  ['CONNECTED', 'Connected'],
]);
